import { useUserStore } from '@/store/use-user-store';
import { Navigate, useParams } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { hasAdminPermissions } = useUserStore();
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  if (!hasAdminPermissions) {
    return <Navigate to={`/${tenantSlug}/home`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
